export default __webpack_public_path__ + "static/media/up_arrow.0a96c6a3.svg";